import { compact, flatMap, keyBy, mapValues } from 'es-toolkit';

import { type FieldValue } from './generated/graphql';

interface PlayResultField {
  values?: null | readonly (FieldValue | null)[];
}

export function toPlayResultNameMap(fields?: null | readonly (null | PlayResultField)[]) {
  const values = compact(flatMap(compact(fields ?? []), ({ values }) => values ?? []));

  return mapValues(
    keyBy(values, ({ value }) => value ?? ''),
    ({ displayValue }) => displayValue ?? '',
  );
}
